import { render, staticRenderFns } from "./status-bar.vue?vue&type=template&id=37540a00"
import script from "./status-bar.vue?vue&type=script&lang=js"
export * from "./status-bar.vue?vue&type=script&lang=js"
import style0 from "./status-bar.vue?vue&type=style&index=0&id=37540a00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports